import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import * as CryptoJS from 'crypto-js';


import {
  APP_STORAGE_USERNAME,
  APP_STORAGE_FIRSTNAME,
  APP_STORAGE_REMEMBERME,
  DataService,
  NonComplianceSummary, ServerConstantsService
} from '../shared';
import { CommonUtility, AuthService } from '../shared';
import { TokenStorage } from '../shared/Utility/TokenStorage';
import { ReferenceTableService } from '../reference-table.service';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { NotificationsService } from 'angular2-notifications';
import { error } from 'util';


@Component({
  selector: 'app-login-dhs',
  templateUrl: './login-dhs.component.html',
  styleUrls: ['./login-dhs.component.scss']
})
export class LoginDhsComponent implements OnInit {
  /* Route params */

  /* Page models */
  username: string;
  password: string = '';
  encryPassword: string;
  rememberMeSw = false;
  errMessage:any = 'Username or Password is Incorrect.'
  /* Miscellaneous */
  loginFailed = false;
  baseLine: any;
  userActionNotificationsMap: any;

  ServerConstants: any;
  showFlag:Boolean = false;
  buildConstants: any;
  key:any = '49346A3CD8BFD3F9100B4CE9DAED72B1';
  iv:any = '9836565498764147';
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private titleService: Title,
    private commonUtil: CommonUtility,
    private authService: AuthService,
    private dataService: DataService,
    private tokenStorage: TokenStorage,
    private data: ReferenceTableService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private idle: Idle,
    private keepalive: Keepalive
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    this.buildConstants = serverConstantsService.getBuildConstants();
    /*let postData = {
      "FIMGroups":"ROL_EandTMISSupervisor;ROL_EandTMISWorker"}
      this.http.post<any>('https://manalin/dco/Authenticator/api/Authentication/userAuthentication',postData,{withCredentials:true}).subscribe(
      (val) => {
        console.log(val);
        if(val.isUserAccountValid === true){
          this.authService.attemptAuth({ 'username': val.username, 'password': this.password,'isLDAPAuthenticated':'Y' }).subscribe(data => {
            console.log(data);
            if (data.token) {
              console.log(data);
              // Persist session (i.e. post-authentication response)
              this.dataService.addValueToSharedDataMap('token', data.token);
              this.authService.signIn(data);
              sessionStorage.setItem('FirstName', data.firstName);
              // this.data.firstName.next(sessionStorage.getItem('firstName'));
              this.dataService.addValueToSharedDataMap('current_user_full_name', data.firstName + ' ' + data.lastName);
              this.dataService.addValueToSharedDataMap('firstName', data.firstName);
              this.dataService.addValueToSharedDataMap('lastName', data.lastName);
              this.dataService.addValueToSharedDataMap('current_user', data.username);
              this.dataService.addValueToSharedDataMap('tempPasswordSw', data.tempPasswordSw);
              this.dataService.addValueToSharedDataMap('expirationSw', data.expirationSw);
              // Retrieve reference tables
              this.data.loadData();
              this.data.currentMessage.subscribe(
                (message) => {
                  this.data.parseRefTableData(message);
                });
              // Retrieve page roles
              this.dataService.loadPageRolesData();
              this.idle.watch();
    
              if (data.expirationSw) {
                this.notificationService.warn('Login', 'Your current password expired.');
    
              }
              // Redirect to dashboard
              if (data.tempPasswordSw === 'Y' || (data.expirationSw)) {
                this.dataService.removeValueFromSharedDataMap('token');
                sessionStorage.removeItem('FirstName');
                this.router.navigate(['reset']);
    
              } else {
    
                this.router.navigate(['dashboard']);
              }
    
            } else {
              this.loginFailed = true;
            }
          }, response => {
            this.loginFailed = true;
          }, () => {
    
          });
        }
        else{
          console.log(val.substring(0,5));
        }
      },error=>{
        console.log("Error Occured During get user call");
      });*/
  }

  ngOnInit() {
    // If authenticated, redirect to dashboard page
    this.dataService.addValueToSharedDataMap('ISWORKERPORTAL', true);
    this.dataService.isWorker = true;
    this.idle.stop();
    this.baseLine = this.buildConstants.BUILD_NUMBER + '  :  ' + this.buildConstants.BUILD_TIME;
    if (sessionStorage.getItem('FirstName')) {
      this.router.navigate(['dashboard']);

    }

    // Retrieve username from session storage
    if (window.localStorage.getItem(APP_STORAGE_REMEMBERME) === 'Y') {
      this.rememberMeSw = true;
      this.username = window.localStorage.getItem(APP_STORAGE_USERNAME);
    }
  }

  openForgortPassword() {
    this.router.navigate(['forgotPassword']);

  }
  restrict(event) {
    if (event.key !== '.' && event.key !== '@') {
      return true;
    }
    else {
      return false;
    }
  }

  processLogin(){
    let key1 = CryptoJS.enc.Utf8.parse(this.key);
    let iv = CryptoJS.enc.Utf8.parse(this.iv);
    let encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(this.password), key1,
        {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
      console.log(encrypted.toString());
      this.encryPassword = encrypted.toString();
      this.doLogin();
      /*let body = {"UserName":this.username,
      "Password":encrypted.toString(),
      "FIMGroups":"ROL_EandTMISSupervisor;ROL_EandTMISWorker;ROL_DeloitteTicketTracking"}
      this.http.post<any>('https://manalin/dco/Authenticator/api/Authentication/getldapauth',body).subscribe(
        (val) => {
          if(val.isUserAccountValid === true ){
            this.username = val.userData.userName.toLowerCase();
            this.doLogin();
          }
          else if(val.isUserAccountValid === false && val.userData !== null){
            this.errMessage = 'Username is Not Authorized.'
            this.loginFailed = true;
          }
          else{
            this.loginFailed = true;
          }
        },error=>{
          console.log("Error Occured during post call");
          this.loginFailed = true;
        }
        );
        //this.doLogin();*/
  }
  // Process login
  doLogin() {
    if (this.username.indexOf('@') > -1 || this.username.indexOf('.') > -1) {

      this.showFlag = true;
      this.loginFailed = false;
    } else {
      // Remove login error message
      this.loginFailed = false;
      this.showFlag = false;

      // If Remember Me is enabled, persist 'username' in session
      if (this.rememberMeSw === true) {
        window.localStorage.setItem(APP_STORAGE_REMEMBERME, 'Y');
      } else {
        window.localStorage.removeItem(APP_STORAGE_REMEMBERME);
      }

      this.dataService.addValueToSharedDataMap('username', this.username);

      // Generate input load
      const inputLoad = { 'username': this.username, 'password': this.encryPassword, 'isLDAPAuthenticated':'Y' };

      // POST Call: Retrieve token from backend
      this.authService.attemptAuth(inputLoad).subscribe(data => {
        if (data.token) {
          console.log(data);
          // Persist session (i.e. post-authentication response)
          this.dataService.addValueToSharedDataMap('token', data.token);
          this.authService.signIn(data);
          sessionStorage.setItem('FirstName', data.firstName);
          // this.data.firstName.next(sessionStorage.getItem('firstName'));
          this.dataService.addValueToSharedDataMap('current_user_full_name', data.firstName + ' ' + data.lastName);
          this.dataService.addValueToSharedDataMap('firstName', data.firstName);
          this.dataService.addValueToSharedDataMap('lastName', data.lastName);
          this.dataService.addValueToSharedDataMap('current_user', data.username);
          this.dataService.addValueToSharedDataMap('tempPasswordSw', data.tempPasswordSw);
          this.dataService.addValueToSharedDataMap('expirationSw', data.expirationSw);
          // Retrieve reference tables
          this.data.loadData();
          this.data.currentMessage.subscribe(
            (message) => {
              this.data.parseRefTableData(message);
            });
          // Retrieve page roles
          this.dataService.loadPageRolesData();
          this.idle.watch();
          this.router.navigate(['dashboard']);

        } else if(data.errorCode[0].description === "Username is Not Authorized.") {
          this.errMessage = 'Username is not  Authorized.'
          this.loginFailed = true;
        }
        else if(data.errorCode[0].description === "Invalid username or password.") {
          this.errMessage = 'Username is not a member of SNAPWorks.'
          this.loginFailed = true;
        }
        else{
          this.errMessage = 'Username or Password is Incorrect.'
          this.loginFailed = true;
        }
      }, response => {
        console.log("MANALIN Post call failed.")
        this.loginFailed = false;
      }, () => {

      });

    }
  }


  /**
   * 
   * @param event Process login when 'Enter' key is pressed
   */
  onEnterSubmit(event: KeyboardEvent) {
    const KEY_ENTER = 13;

    if (event.keyCode != KEY_ENTER) {
      return;
    }

    event.preventDefault;
    document.getElementById('loginBtn').click();
  }

}



// WEBPACK FOOTER //
// ./src/app/login-dhs/login-dhs.component.ts